/* eslint-disable react/no-danger */
import React, { memo, useCallback } from 'react';
import useProductWsMessageData from '../../../hooks/inbox/data/useProductWsMessageData';
import ImageMC from '../../../components/ImageMC';

/**
 * RepliedProductWsMessageMC - Preview de mensaje de producto WhatsApp al citar en el Inbox.
 */
const RepliedProductWsMessageMC = memo(({ conversation, message, onImageClick }) => {
  const {
    data,
    productName,
    productDetailsHtml,
    captionHtml,
    url
  } = useProductWsMessageData({ platform: conversation.platform, message });

  const handleImageClick = useCallback(() => {
    if (!url || typeof onImageClick !== 'function') return;
    onImageClick(message.id || message.identifier);
  }, [url, onImageClick, message.id, message.identifier]);

  const previewParts = [];
  if (productName) previewParts.push(productName);
  if (productDetailsHtml) previewParts.push(productDetailsHtml);
  if (captionHtml) previewParts.push(captionHtml);
  const previewHtml = previewParts.join('<br />');

  return (
    <div className="tw-flex tw-items-center">
      {previewHtml && (
        <div
          className="tw-p-2 tw-flex-1 tw-min-w-0 tw-text-pre-line tw-text-left tw-text-xs"
          dangerouslySetInnerHTML={{ __html: previewHtml }}
        />
      )}
      {url && (
        <div className="tw-p-2 tw-w-[64px] tw-h-[64px] tw-flex-shrink-0">
          <ImageMC
            platform={conversation.platform}
            data={data}
            onClick={handleImageClick}
            className="tw-block tw-w-full tw-h-full tw-object-cover tw-rounded-[9px] tw-bg-white tw-cursor-pointer !tw-max-w-none !tw-max-h-none"
          />
        </div>
      )}
    </div>
  );
});

RepliedProductWsMessageMC.displayName = 'RepliedProductWsMessageMC';

export default RepliedProductWsMessageMC;
